<div class="relative isolate overflow-hidden">
    <div class="mx-auto max-w-7xl px-6 pb-24 pt-10 sm:pb-32 md:flex md:px-8 md:py-40">
        <div class="mx-auto max-w-2xl shrink-0 md:mx-0 md:pt-8 text-center md:text-left">
            <h1 class="mt-10 text-pretty text-5xl font-semibold tracking-tight sm:text-7xl text-normal" >{{componentModel.title.value}}</h1>
            <p class="mt-8 text-pretty text-lg font-medium sm:text-xl/8 text-normal">{{componentModel.description.value}}</p>
            <div class="mt-10 md:flex md:items-center gap-x-6">
                <white-label-button [text]="componentModel.buttonText.value" [link]="componentModel.buttonLink.value"></white-label-button>
            </div>
        </div>
        <div class="mx-auto mt-16 max-w-2xl sm:mt-24 md:ml-10 lg:mr-0 md:mt-0 md:max-w-none md:flex-none xl:ml-32 md:block hidden">
            <div class="max-w-3xl flex-none sm:max-w-5xl md:max-w-none">
                <img [src]="componentModel.imageUrl.value" alt="App screenshot" width="2432" height="1442" class="w-[76rem] rounded-md bg-white/5 shadow-2xl ring-1 ring-white/10">
            </div>
        </div>
    </div>
</div>



